module.exports = __webpack_public_path__ + "static/media/tut1.78f2a81f.png";